import React, { useMemo } from 'react';
import { useI18n } from '../i18n/index.jsx';
import { countryOptions } from '../countries.js';
import { REGIONS, placeLabel } from '../companyOptions.js';

// Toggle chips for a short fixed list (markets, provinces).
export function ChipChoice({ id, options, value, onChange, label, disabled }) {
  const toggle = (code) => onChange(value.includes(code) ? value.filter((c) => c !== code) : [...value, code]);
  return (
    <div className="chip-choice" role="group" aria-labelledby={id}>
      {options.map((o) => (
        <label key={o.code} className={`chip-toggle${value.includes(o.code) ? ' on' : ''}`}>
          <input type="checkbox" className="sr-only" checked={value.includes(o.code)} onChange={() => toggle(o.code)} disabled={disabled} aria-label={o.name} />
          {value.includes(o.code) && <span className="chip-check" aria-hidden="true">✓</span>}{o.name}
        </label>
      ))}
      <span id={id} className="sr-only">{label}</span>
    </div>
  );
}

// Regions + every country: chosen ones as removable chips, plus an "Add…"
// dropdown (regions first, then countries A–Z).
export function PlacePicker({ id, value, onChange, disabled }) {
  const { t, lang } = useI18n();
  const countries = useMemo(() => countryOptions(lang), [lang]);
  const add = (code) => { if (code && !value.includes(code)) onChange([...value, code]); };
  return (
    <div className="place-picker">
      {value.length > 0 && (
        <ul className="chip-list">
          {value.map((code) => (
            <li key={code} className="chip">
              {placeLabel(code, t, lang)}
              {!disabled && <button type="button" onClick={() => onChange(value.filter((c) => c !== code))} aria-label={t('company.removeItem', { item: placeLabel(code, t, lang) })}>×</button>}
            </li>
          ))}
        </ul>
      )}
      <select id={id} value="" onChange={(e) => add(e.target.value)} disabled={disabled || value.length >= 60}>
        <option value="">{t('company.addPlace')}</option>
        <optgroup label={t('company.regionsGroup')}>
          {REGIONS.filter((r) => !value.includes(r)).map((r) => <option key={r} value={r}>{t(`regions.${r}`)}</option>)}
        </optgroup>
        <optgroup label={t('company.countriesGroup')}>
          {countries.filter((c) => !value.includes(c.code)).map((c) => <option key={c.code} value={c.code}>{c.name}</option>)}
        </optgroup>
      </select>
    </div>
  );
}
